'use client'

import * as React from 'react'
import Image, { type ImageProps } from 'next/image'

// next/image with a graceful fallback.
//
// Several demo/UGC surfaces hotlink images.unsplash.com directly. Unsplash
// throttles hotlinked images intermittently (and the odd ID goes stale),
// which made next/image render the browser's broken-image icon on the
// hero thumbnail, the collage gutters and the widget-builder preview.
// On error we swap to a tasteful tinted tile so the layout stays intact
// and nothing ever reads as "broken".

export function ImgWithFallback({
  className,
  fallbackClassName,
  alt = '',
  fill,
  onError,
  ...rest
}: ImageProps & { fallbackClassName?: string }) {
  const [failed, setFailed] = React.useState(false)

  if (failed) {
    return (
      <span
        aria-hidden
        className={[
          fill ? 'absolute inset-0' : 'block h-full w-full',
          'bg-gradient-to-br from-secondary via-muted to-secondary',
          fallbackClassName ?? className ?? '',
        ].join(' ')}
      />
    )
  }

  return (
    <Image
      {...rest}
      fill={fill}
      alt={alt}
      className={className}
      onError={(e) => {
        setFailed(true)
        onError?.(e)
      }}
    />
  )
}
